import React, { useState, useContext } from "react";
import Select from "react-select";
import { Button } from "rsuite";
import { useQuery } from "@tanstack/react-query";
import { SelectPicker } from "rsuite";

import "./index.css";
import { RiDeleteBin6Line } from "react-icons/ri";
import { IoMdAddCircleOutline } from "react-icons/io";
import { ConfiguracaoGlebaContext } from "../../../../../../contexts/ConfiguracaoGlebaContext";
import {
  getProdutoAdubacao,
  getTipoAdubacao,
  getEpocaAdubacao,
} from "../../../../../../Services/programation.service";

function Adubacao() {
  const { configuracaoGleba, setConfiguracaoGleba, activeCulturaIndex, setProgramacaoAlterada } = useContext(
    ConfiguracaoGlebaContext
  );

  const handleAddRow = () => {
    setProgramacaoAlterada(true);
    setConfiguracaoGleba((prevState) => ({
      ...prevState,
      culturas: prevState.culturas.map((cultura, i) =>
        i === activeCulturaIndex
          ? {
              ...cultura,
              adubacao: [
                ...(cultura?.adubacao ? cultura.adubacao : []),
                {
                  id: Date.now(),
                  quantidade: null,
                  taxaVariavel: false,
                  produtoAdubacaoId: "",
                  epocaAdubacaoId: "",
                  tipoAdubacaoId: "",
                },
              ],
            }
          : cultura
      ),
    }));
  };

  const handleRemoveRow = (idToRemove) => {
    setProgramacaoAlterada(true);
    setConfiguracaoGleba((prevState) => ({
      ...prevState,
      culturas: prevState.culturas.map((cultura, i) =>
        i === activeCulturaIndex
          ? {
              ...cultura,
              adubacao: (cultura.adubacao || []).filter(
                (item) => item.id !== idToRemove
              ),
            }
          : cultura
      ),
    }));
  };

  const handleMoveRow = (index, direction) => {
    setProgramacaoAlterada(true);
    setConfiguracaoGleba((prevState) => ({
      ...prevState,
      culturas: prevState.culturas.map((cultura, i) => {
        if (i !== activeCulturaIndex) return cultura;
        const lista = [...(cultura.adubacao || [])];
        const novoIndex = index + direction;
        if (novoIndex < 0 || novoIndex >= lista.length) return cultura;
        [lista[index], lista[novoIndex]] = [lista[novoIndex], lista[index]];
        return { ...cultura, adubacao: lista };
      }),
    }));
  };

  const AdubacaoConfigurationFetch = async () => {
    const {
      res: { data: produtoAdubacaoData },
    } = await getProdutoAdubacao();
    const {
      res: { data: tipoAdubacaoData },
    } = await getTipoAdubacao();
    const {
      res: { data: epocaAdubacaoData },
    } = await getEpocaAdubacao();
    return {
      produtoAdubacao: produtoAdubacaoData
        .filter((item) => !item.excluido)
        .map((item) => ({
          label: item.nome,
          value: item.id,
        })),
      tipoAdubacao: tipoAdubacaoData
        .filter((item) => !item.excluido)
        .map((item) => ({
          label: item.nome,
          value: item.id,
        })),
      epocaAdubacao: epocaAdubacaoData
        .filter((item) => !item.excluido)
        .map((item) => ({
          label: item.nome,
          value: item.id,
        })),
      taxaVariavel: [
        {
          label: "Sim",
          value: true,
        },
        {
          label: "Não",
          value: false,
        },
      ],
    };
  };
  const configOptionsQueryAdubacao = useQuery(
    ["configOptionsQueryAdubacao"],
    AdubacaoConfigurationFetch,
    {
      produtoAdubacao: [],
      tipoAdubacao: [],
      epocaAdubacao: [],
      taxaVariavel: [
        {
          label: "Sim",
          value: true,
        },
        {
          label: "Não",
          value: false,
        },
      ],
    }
  );

  // Atualiza SEM mutar o estado (mutação direta corrompe o prevState de
  // outras atualizações no mesmo lote e quebra comparações do React).
  const atualizarLinha = (name, index, value) => {
    setProgramacaoAlterada(true);
    setConfiguracaoGleba((prevState) => ({
      ...prevState,
      culturas: (prevState.culturas || []).map((cultura, i) =>
        i === activeCulturaIndex
          ? {
              ...cultura,
              adubacao: (cultura.adubacao || []).map((item, j) =>
                j === index ? { ...item, [name]: value } : item
              ),
            }
          : cultura
      ),
    }));
  };

  const handleSelectChange = (name, index) => {
    return (option) => atualizarLinha(name, index, option.value);
  };

  const handleInputChange = (name, index) => {
    return (e) => atualizarLinha(name, index, e.target.value);
  };

  // const colourStyles = {
  //   control: (styles) => ({
  //     ...styles,
  //     backgroundColor: "white",
  //     zIndex: "9999",
  //   }),
  //   option: (styles, { data, isDisabled, isFocused, isSelected }) => {
  //     return {
  //       ...styles,
  //       backgroundColor: isDisabled ? "red" : "blue",
  //       color: "#FFF",
  //       cursor: isDisabled ? "not-allowed" : "default",
  //       zIndex: "99999",
  //     };
  //   },
  // };

  return (
    <div className="table-responsive">
      <div className="title-card">ADUBAÇÃO</div>
      {configuracaoGleba.culturas.length !== 0 ? (
        <>
        <table className="table">
          <tbody style={{ width: "100%", marginBottom: "0px" }}>
            {(configuracaoGleba?.culturas?.[activeCulturaIndex]?.adubacao || []).map(
              (rowData, index) => (
                <tr
                  style={{
                    display: "flex",
                    width: "max-content",
                    boxShadow: "0px -4px 12px -1px rgba(0,0,0,0.45)",
                    margin: "10px",
                    // border: "solid 2px #dfdfdf",
                    borderRadius: "6px",
                    padding: "5px",
                    background: "rgba(1, 104, 32, 0.1)",
                  }}
                  key={rowData.id}
                >
                  <th
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      padding: "0 4px",
                    }}
                  >
                    <button
                      type="button"
                      className="button-move"
                      disabled={index === 0}
                      style={{
                        background: "transparent",
                        border: "none",
                        cursor: "pointer",
                        fontWeight: "bold",
                        color: "rgba(1,104,32,0.9)",
                        lineHeight: "1",
                        opacity: index === 0 ? 0.25 : 1,
                      }}
                      onClick={() => handleMoveRow(index, -1)}
                      title="Subir"
                    >
                      ▲
                    </button>
                    <button
                      type="button"
                      className="button-move"
                      disabled={
                        index ===
                        (configuracaoGleba?.culturas?.[activeCulturaIndex]
                          ?.adubacao?.length || 0) - 1
                      }
                      style={{
                        background: "transparent",
                        border: "none",
                        cursor: "pointer",
                        fontWeight: "bold",
                        color: "rgba(1,104,32,0.9)",
                        lineHeight: "1",
                        opacity:
                          index ===
                          (configuracaoGleba?.culturas?.[activeCulturaIndex]
                            ?.adubacao?.length || 0) - 1
                            ? 0.25
                            : 1,
                      }}
                      onClick={() => handleMoveRow(index, 1)}
                      title="Descer"
                    >
                      ▼
                    </button>
                  </th>
                  <div className="column-configs-table">
                    <th className="correct-inline">Produto</th>
                    <td>
                      <Select
                        // styles={colourStyles}
                        menuPosition="fixed"
                        defaultValue={{
                          label: rowData?.produtoAdubacao?.nome,
                          value: rowData?.produtoAdubacao?.id,
                        }}
                        onChange={handleSelectChange(
                          "produtoAdubacaoId",
                          index
                        )}
                        // onChange={setSelectedOption}
                        options={
                          configOptionsQueryAdubacao?.data?.produtoAdubacao
                        }
                      />
                    </td>
                  </div>
                  <div className="column-configs-table">
                    <th className="correct-inline">Tipo</th>
                    <td>
                      <Select
                        menuPosition="fixed"
                        defaultValue={{
                          label: rowData?.tipoAdubacao?.nome,
                          value: rowData?.tipoAdubacao?.id,
                        }}
                        onChange={handleSelectChange("tipoAdubacaoId", index)}
                        // onChange={setSelectedOption}
                        options={configOptionsQueryAdubacao?.data?.tipoAdubacao}
                      />
                    </td>
                  </div>
                  <div className="column-configs-table">
                    <th className="correct-inline">Época</th>
                    <td>
                      <Select
                        menuPosition="fixed"
                        defaultValue={{
                          label: rowData?.epocaAdubacao?.nome,
                          value: rowData?.epocaAdubacao?.id,
                        }}
                        onChange={handleSelectChange("epocaAdubacaoId", index)}
                        options={
                          configOptionsQueryAdubacao?.data?.epocaAdubacao
                        }
                      />
                    </td>
                  </div>

                  <div className="column-configs-table">
                    <th className="correct-inline">Quantidade/ha (l ou Kg)</th>
                    <td>
                      <input
                        className="input-atributo"
                        type="number"
                        value={rowData?.quantidade ?? ""}
                        onChange={handleInputChange("quantidade", index)}
                      />
                    </td>
                  </div>
                  <div className="column-configs-table">
                    <th className="correct-inline">Área</th>
                    <td>
                      <input
                        className="input-atributo"
                        type="number"
                        value={
                          rowData.area
                            ? rowData.area
                            : configuracaoGleba.culturas[activeCulturaIndex]
                                ?.area || ""
                        }
                        onChange={handleInputChange("area", index)}
                      />
                    </td>
                  </div>
                  <div className="column-configs-table">
                    <th className="correct-inline coluna-total">
                      Quantidade Total (l ou Kg)
                    </th>
                    <td>
                      <input
                        style={{
                          background: "rgba(1, 104, 32, 0.1)",
                          fontWeight: "bold",
                          color: "black",
                          fontSize: "15px",
                          textAlign: "center",
                        }}
                        disabled="true"
                        className="input-atributo"
                        type="number"
                        value={parseFloat(
                          rowData?.area * rowData?.quantidade ||
                            (configuracaoGleba.culturas[activeCulturaIndex]
                              ?.area || 0) * rowData?.quantidade ||
                            0
                        ).toFixed(2)}
                      />
                    </td>
                  </div>
                  <div className="column-configs-table">
                    <th className="correct-inline">Estádio</th>
                    <td>
                      <input
                        className="input-atributo"
                        type="text"
                        value={rowData?.estadio}
                        onChange={handleInputChange("estadio", index, "text")}
                      />
                    </td>
                  </div>
                  <th>
                    <button
                      className="button-remove"
                      variant="danger"
                      onClick={() => handleRemoveRow(rowData.id)}
                    >
                      <RiDeleteBin6Line />
                    </button>
                  </th>
                </tr>
              )
            )}
          </tbody>
        </table>
        {/* Botão FORA da <table>: <button> filho direto de <tbody> é HTML inválido */}
        <button
          className="button-add"
          variant="danger"
          onClick={() => handleAddRow()}
        >
          <IoMdAddCircleOutline />
        </button>
        </>
      ) : (
        <>
          <div className="no-data-info">Você não possui dados cadastrados.</div>
          <Button
            className="button-add1"
            variant="danger"
            onClick={() => handleAddRow()}
          >
            <IoMdAddCircleOutline />
          </Button>
        </>
      )}
    </div>
  );
}

export default Adubacao;
